import React, { Component } from 'react';
import { validateUniqueCharacters } from '../../utils/functions';
import ChangePasswordForm from 'components/ChangePassword/ChangePasswordForm';
import { SubmissionError } from 'redux-form/immutable';
import NotificationWindow from '../NotificationWindow';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import {
  ERROR_PASSWORD_TOO_LONG,
  ERROR_PASSWORD_TOO_SHORT,
  ERROR_PASSWORD_MUST_CONTAIN_UNIQUE,
  ERROR_PASSWORDS_DO_NOT_MATCH,
  ERROR_SERVER_ERROR,
  SUCCESS_MESSAGE,
  SUCCESS_MESSAGE_MOBILE,
  GLOBAL_RESET_PASSWORD_SUCCESSFUL
} from 'utils/constants';
import MobileDetect from 'mobile-detect';

class CompletePasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitErrors: [],
      successful: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.mobileDetect = new MobileDetect(window.navigator.userAgent);
  }

  handleSubmit(values) {
    const obj = values.toJS();

    this.setState({ submitErrors: [] });

    if (
      obj.confirmPassword.length > 0 &&
      obj.password !== obj.confirmPassword
    ) {
      throw new SubmissionError({
        _error: ERROR_PASSWORDS_DO_NOT_MATCH
      });
    }

    if (obj.password.length > 0 && obj.password.length < 8) {
      throw new SubmissionError({
        _error: ERROR_PASSWORD_TOO_SHORT
      });
    }

    if (obj.password.length > 0 && obj.password.length > 64) {
      throw new SubmissionError({
        _error: ERROR_PASSWORD_TOO_LONG
      });
    }

    if (!validateUniqueCharacters(obj.password, 3)) {
      throw new SubmissionError({
        _error: ERROR_PASSWORD_MUST_CONTAIN_UNIQUE
      });
    }

    return this.props
      .resetPassword(obj.password, this.props.resetToken)
      .then(res => {
        if (
          res &&
          res.data &&
          res.data.resetPassword &&
          typeof res.data.resetPassword.success !== 'undefined'
        ) {
          if (res.data.resetPassword.success) {
            this.setState({
              successful: true
            });

            if (!this.mobileDetect.mobile()) {
              this.props.redirectToLogin();
            }
          } else {
            this.setState({
              submitErrors: [res.data.resetPassword.message]
            });
          }
        } else {
          this.setState({ submitErrors: [ERROR_SERVER_ERROR] });
        }
        return res;
      })
      .catch(() => {
        this.setState({ submitErrors: [ERROR_SERVER_ERROR] });
      });
  }

  render() {
    if (this.state.successful) {
      const successMsg = this.mobileDetect.mobile()
        ? SUCCESS_MESSAGE_MOBILE
        : SUCCESS_MESSAGE;

      return <NotificationWindow message={successMsg} />;
    } else {
      return (
        <ChangePasswordForm
          resetPassword={true}
          onSubmit={this.handleSubmit}
          submitErrors={this.state.submitErrors}
          successful={this.state.successful}
        />
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    redirectToLogin: () =>
      dispatch(push(`/login?message=${GLOBAL_RESET_PASSWORD_SUCCESSFUL}`))
  };
};

export default connect(null, mapDispatchToProps)(CompletePasswordReset);



// WEBPACK FOOTER //
// ./src/components/CompletePasswordReset/index.js